import React, { useState, useEffect } from "react";
import MainDashboard from "./MainDashboard";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState("");
  const [admins, setAdmins] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  // Admin check
  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    const role = localStorage.getItem("adminRole");
    if (!token || !["admin", "super user"].includes(role)) {
      navigate("/admin");
    } else {
      setUserRole(role);
      if (role === "admin") {
        fetchAdmins();
      }
    }
  }, [navigate]);

  const fetchAdmins = async (page = 1) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("adminToken");
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/users?page=${page}&limit=10`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const mappedAdmins = response.data.map((admin) => ({
        id: admin._id,
        name: admin.username,
        displayEmail: admin.username.toLowerCase() + "@praisesawa.com",
        email: admin.username.toLowerCase() + "@praisesawa.com",
        role: admin.role,
        employment: admin.role === "admin" ? "Full Access" : "Limited Access",
        status: "Active",
        note: admin.role === "admin" ? "System Admin" : "Content Manager",
      }));
      setAdmins(mappedAdmins);
      setTotalPages(Math.ceil(response.data.length / 10));
      setCurrentPage(page);
    } catch (err) {
      if (err.response?.status === 401) {
        handleLogout();
      } else {
        setError(
          err.response?.data?.message || t("adminSettings.error.fetchAdmins")
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/logout`);
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminRole");
      navigate("/admin");
      window.location.reload();
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  return (
    <div className="flex overflow-hidden h-full px-3 sm:px-6 py-4 sm:py-6">
      {children || <MainDashboard />}
    </div>
  );
};

export default DashboardLayout;
